import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MediaService } from '@studiobuki/web-core/lib/media';
import { MediaObserver } from '@angular/flex-layout';
import type { TPhoto } from '@shared/common/data/products';
import SwiperCore, { Autoplay, Pagination, Navigation } from 'swiper';

SwiperCore.use([Autoplay, Pagination, Navigation]);

@Component({
  selector: 'app-banner-one',
  templateUrl: './banner-one.component.html',
  styleUrls: ['./banner-one.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BannerOneComponent {
  public readonly photos: TPhoto[] = [
    'assets/images/banner-one/header_PC_01.jpg',
    'assets/images/banner-one/header_PC_02.jpg',
    'assets/images/banner-one/header_PC_03.jpg',
    'assets/images/banner-one/header_PC_04.jpg',
    'assets/images/banner-one/header_PC_05.jpg',
  ];

  private readonly mobilePhotos: TPhoto[] = [
    'assets/images/banner-one/header_mobile_01.jpg',
    'assets/images/banner-one/header_mobile_02.jpg',
    'assets/images/banner-one/header_mobile_03.jpg',
    'assets/images/banner-one/header_mobile_04.jpg',
    'assets/images/banner-one/header_mobile_05.jpg',
  ];

  constructor(
    public mediaService: MediaService,
    public media: MediaObserver,
  ) {}

  public getCurrentSlides(): TPhoto[] {
    if (!this.media.isActive('gt-md') || !this.media.isActive('gt-sm'))
      return this.mobilePhotos;
    return this.photos;
  }
}
